export const GET_SCENES = "GET_SCENES";
export const CREATE_SCENE_TAG = "CREATE_SCENE_TAG";
export const REMOVE_SCENE_TAG = "REMOVE_SCENE_TAG";
export const GET_SCENE_CURRENT = "GET_SCENE_CURRENT";
export const TOTAL_PAGES_SCENES = "TOTAL_PAGES_SCENES";
export const PAGINATION_PARAMS_SCENES = "PAGINATION_PARAMS_SCENES";
export const COUNT_SCENES = "COUNT_SCENES";
export const SCENE_TAG_HINTS = "SCENE_TAG_HINTS";
export const SCENE_CLONE = "SCENE_CLONE";
